import React, { createContext, useContext, useEffect, useState } from "react";

/**
 * RfqBasketContext — the SCHOOL-only equivalent of the parent Cart.
 * Deliberately excludes price / total fields so the UI cannot leak them.
 * Persisted in localStorage so schools can build a basket over multiple pages.
 */
const KEY = "schoollane:rfq-basket:v1";
const RfqBasketContext = createContext();

export function RfqBasketProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => setItems((prev) => {
    const ex = prev.find((x) => x.product_id === p.id);
    if (ex) return prev.map((x) => x.product_id === p.id ? { ...x, qty: x.qty + qty } : x);
    return [...prev, {
      product_id: p.id,
      name: p.name,
      image: p.image,
      category: p.category,
      qty: Math.max(1, qty),
      notes: "",
    }];
  });
  const remove = (id) => setItems((p) => p.filter((x) => x.product_id !== id));
  const setQty = (id, qty) => setItems((p) => p.map((x) =>
    x.product_id === id ? { ...x, qty: Math.max(1, qty) } : x));
  const setNotes = (id, notes) => setItems((p) => p.map((x) =>
    x.product_id === id ? { ...x, notes } : x));
  const clear = () => setItems([]);
  const totalUnits = items.reduce((s, x) => s + x.qty, 0);

  return (
    <RfqBasketContext.Provider value={{ items, add, remove, setQty, setNotes, clear, totalUnits }}>
      {children}
    </RfqBasketContext.Provider>
  );
}

export const useRfqBasket = () => useContext(RfqBasketContext);
